import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

export interface IAppConfig {
    maintenance: boolean;
    baseURI: string;
    processBaseURI: string;
    environment: string;
    version: string;
    processCount: number;
}

@Injectable()
@Injectable()
export class AppConfig {
    static settings: IAppConfig;
    constructor(private readonly http: HttpClient) {
    }

    load() {
        return this.http.get<IAppConfig>(location.origin + "/assets/settings.json", { headers: { ignoreLoadingBar: "", "Auth": "False" } })
            .subscribe(
                (response: IAppConfig) => {
                    AppConfig.settings = response;
                },
                () => {
                    AppConfig.settings = { maintenance: false, baseURI: "", processBaseURI: "", environment: "", version: "", processCount: 2 };
                }
            );
    }

    getURI(base: string, endPoint: string, params?: any): string {
        let paramsUrl = "";
        if (params) {
            paramsUrl = params.join("/");
        }

        return AppConfig.settings.baseURI + base + "/" + endPoint + "/" + paramsUrl;
    }

    getProcessURI(): string {
        return AppConfig.settings.processBaseURI;
    }

    getEnvironment(): string {
        return AppConfig.settings.environment;
    }

    getVersion(): string {
        return AppConfig.settings.version;
    }

    getProcessCount(): number {
        return AppConfig.settings.processCount;
    }
}
